import { useMemo } from 'react';
import { WeddingPlotPlane3D } from '@/src/modules/templates/WeddingPlotPlane3D';
import { PLOT_PLANE_DEMO_DATA } from '@/src/modules/templates/WeddingPlotPlane3D/content';
import { withDemoPlanePhotos } from '@/src/modules/templates/WeddingPlotPlane3D/planeSources';

/** Public preview of the plot-plane wedding, no login required. */
export function WeddingPlotPlaneDemo() {
  const data = useMemo(
    () => withDemoPlanePhotos(PLOT_PLANE_DEMO_DATA, window.location.search),
    [],
  );

  return (
    <div className="min-h-screen bg-[#140a07]">
      <WeddingPlotPlane3D data={data} />
    </div>
  );
}
